import ErrorView from "src/views/errors/ErrorView";
import React from "react";
import { appInsights } from 'src/AppInsights';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    // Log the error to Application Insights
    appInsights.trackException({ error, errorInfo });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <ErrorView error={this.state.error} errorInfo={this.state.errorInfo} />
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
